
import Vue from 'vue';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import api from '@/api/api';
import { formsValidations } from '@/utils/formsValidations';
import ModalCrud from '@/components/ModalCrud.vue';
import Grid from '@/components/Grid.vue';
import type { IReturnXlsxExport } from '@/types/IControleFinanceiro';

export default Vue.extend({
	name: 'ControleFinanceiro',
	data() {
		return {
			table: {
				isLoading: false,
				dataset: [],
				gridItemsActions: [
					{
						label: 'Ver Lote',
						action: 'open',
						icon: 'mdi-view-dashboard-edit-outline',
						color: 'primary',
						display: true,
						loading: false
					},
					{
						label: 'Ativar / Inativar',
						action: 'delete',
						icon: 'mdi-trash-can-outline',
						color: 'red',
						display: true,
						loading: false
					}
				]
			},
			modals: {
				novoLote: {
					data: {
						form: {
							idColaborador: null,
							idStatus: true
						},
						inputs: {
							dsColaboradores: []
						}
					},
					visible: false,
					isLoading: true,
					isValid: false
				},
				filtrarLotes: {
					data: {
						form: {
							colaboradores: [],
							status: [],
							saldoDinheiro: false,
							saldoCartao: false,
						},
						inputs: {
							colaboradores: [],
							status: [
								{
									id: 'A',
									label: 'Ativos'
								},
								{
									id: 'I',
									label: 'Inativos'
								}
							],
						}
					},
					isLoading: false,
					title: 'Filtrar',
					visible: false,
				}
			}
		};
	},
	async mounted() {
		try {
			this.$store.state.loading = true;
			store.commit(M_MENU, "Controle Financeiro");

			if (!(this.$store.state.infoUser.current.supervisor) && !(this.$store.state.infoUser.current.departamento === 4)) {
				await this.redirectUserFinancialBatch();
			} else {
				await this.loadData();
			};

		} catch (error) {
			this.$toast.error(error.message ?? 'Falha na comunicação');
		} finally {
			this.$store.state.loading = false;
		}
	},
	methods: {
		deadActiveLote: async function (item) {
			try {
				await api.patch(`/financial-control/${item.id}`);
				this.$toast.success("Registro alterado!");
				this.loadData();
			} catch (error) {
				this.$toast.error("Falha ao comunicar com o banco de dados!");
			}
		},
		verLote: function (item) {
			this.$router.push({
				path: `/controle-financeiro/${item.id}`,
			})
		},
		handleNovoLote: async function () {
			try {
				this.table.isLoading = true;
				this.modals.novoLote.isLoading = true;
				const { data } = await api.get('/financial-control-data?typeReq=form');
				this.modals.novoLote.data.inputs.dsColaboradores = data.colaboradores;
				this.modals.novoLote.visible = true;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.table.isLoading = false;
				this.modals.novoLote.isLoading = false;
			}
		},
		closeModalNovoLote: function () {
			this.modals.novoLote.visible = false;
			this.modals.novoLote.data = {
				form: {
					idColaborador: null,
					idStatus: true
				},
				inputs: {
					dsColaboradores: []
				}
			};
		},
		submitNovoLote: async function () {
			try {
				this.modals.novoLote.isLoading = true;
				const formValidation = await this.$refs.formNovoLote.validate();

				if (formValidation) {
					this.modals.novoLote.data.form.idStatus ? this.modals.novoLote.data.form.idStatus = 'A' : this.modals.novoLote.data.form.idStatus = 'I';
					await api.post('/financial-control', this.modals.novoLote.data.form);
					this.$toast.success("Novo lote criado!");
					this.closeModalNovoLote();
					this.loadData();
				} else {
					throw new Error("Formulário inválido.");
				}
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.modals.novoLote.isLoading = false;
			}
		},
		handleGridItemsActions: function (action: 'open' | 'delete', item) {
			switch (action) {
				case 'open':
					this.verLote(item);
					break;
				case 'delete':
					this.deadActiveLote(item);
					break;
				default:
					this.$toast.error('Opção de ação inválida!');
			};
		},
		handleFilter: async function () {
			try {
				this.modals.filtrarLotes.isLoading = true;
				this.modals.filtrarLotes.visible = true;
				const { data } = await api.get('/financial-control-data?typeReq=filter');

				this.modals.filtrarLotes.data.inputs.colaboradores = data.colaboradores ?? [];
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.modals.filtrarLotes.isLoading = false;
			}
		},
		destroyFilter: function () {
			this.modals.filtrarLotes.visible = false;
			this.modals.filtrarLotes.data.inputs.colaboradores = [];
		},
		loadData: async function () {
			try {
				this.modals.filtrarLotes.visible = false;
				this.table.isLoading = true;
				const { data } = await api.get('/financial-control?typeReq=grid', {
					params: {
						colaboradores: this.modals.filtrarLotes.data.form.colaboradores,
						status: this.modals.filtrarLotes.data.form.status,
						saldoCartao: this.modals.filtrarLotes.data.form.saldoCartao ? 1 : 0,
						saldoDinheiro: this.modals.filtrarLotes.data.form.saldoDinheiro ? 1 : 0
					}
				});
				this.table.dataset = data;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.table.isLoading = false;
			}
		},
		redirectUserFinancialBatch: async function () {
			try {
				const { data } = await api.get('/financial-control-user');
				this.$router.push(`/controle-financeiro/${data.ID}`)
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
				this.$router.push('/home');
			}
		},
		handleXlsxExport: async function () {
			try {
				this.$store.state.loading = true;
				const { data } = await api.get<IReturnXlsxExport[]>('/financial-control?typeReq=export', {
					params: {
						colaboradores: this.modals.filtrarLotes.data.form.colaboradores,
						status: this.modals.filtrarLotes.data.form.status,
						saldoCartao: this.modals.filtrarLotes.data.form.saldoCartao ? 1 : 0,
						saldoDinheiro: this.modals.filtrarLotes.data.form.saldoDinheiro ? 1 : 0
					}
				});

				const prepareData = data.map(x => {
					return {
						ID_LOTE: x.ID_LOTE,
						COLABORADOR_LOTE: x.COLABORADOR_LOTE,
						STATUS_LOTE: x.STATUS_LOTE,
						ID_LANCAMENTO: x.ID_LANCAMENTO,
						OPERADOR: x.OPERADOR,
						OPERACAO: x.OPERACAO,
						VALOR: x.VALOR ? Number(x.VALOR) : 0,
						OBSERVACAO: x.OBSERVACAO,
						RESPONSAVEL: x.RESPONSAVEL,
						CIDADE: x.CIDADE,
						TIPO: x.TIPO,
						STATUS_LANCAMENTO: x.STATUS_LANCAMENTO,
						DATA_LANCAMENTO: x.DATA_LANCAMENTO,
						COLABORADOR_RATEIO: x.COLABORADOR_RATEIO,
						VALOR_RATEIO: x.VALOR_RATEIO ? Number(x.VALOR_RATEIO) : null,
					}
				});

				const { XlsxExport } = await import('@/utils/xlsxExport');

				let instanceExport = new XlsxExport({
					columns: [
						{
							label: "ID Lote",
							name: "ID_LOTE",
						},
						{
							label: "Colaborador Lote",
							name: "COLABORADOR_LOTE",
						},
						{
							label: "Status Lote",
							name: "STATUS_LOTE",
						},
						{
							label: "Operador Lcto",
							name: "OPERADOR",
						},
						{
							label: "Operação Lcto",
							name: "OPERACAO",
						},
						{
							label: "Data Lcto",
							name: "DATA_LANCAMENTO",
							isDate: true,
						},
						{
							label: "Valor Total Lcto",
							name: "VALOR",
							isCurrency: true,
						},
						{
							label: "Observação Lcto",
							name: "OBSERVACAO",
						},
						{
							label: "Responsável Lcto",
							name: "RESPONSAVEL",
						},
						{
							label: "Cidade Lcto",
							name: "CIDADE",
						},
						{
							label: "Tipo Lcto",
							name: "TIPO",
						},
						{
							label: "ID Lcto",
							name: "ID_LANCAMENTO",
						},
						{
							label: "Colaborador Rateio",
							name: "COLABORADOR_RATEIO",
						},
						{
							label: "Valor Rateio",
							name: "VALOR_RATEIO",
							isCurrency: true,
						},
						{
							label: "Status Lcto",
							name: "STATUS_LANCAMENTO",
						},
					],
					data: prepareData,
					title: `Controle Financeiro Lotes`
				});

				await instanceExport.export();
				instanceExport = null;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.$store.state.loading = false;
			}
		},
	},
	setup() {
		return {
			columns,
			formsValidations
		};
	},
	components: {
		ModalCrud,
		Grid
	}
})

